import QuestionSVG from '../../assets/svg/question.svg';
export default QuestionSVG;
